export default {
    name: "neo-extras",
    components: {},
    props: [],
    data() {
        return {};
    },
    computed: {},
    mounted() {},
    methods: {},
};
